import ApiService from '@/services/core/api.service'

const SharedDashboardService = {
  async get (query = '') {
    return ApiService.get(`shared/get-total-sales?${query}`)
  }
}

export default SharedDashboardService
